export const createEntityMutation = (
    companyId: number, name: string, abbreviation: string, bucketName: string, domains: string) =>
{
    return `mutation {
        createEntity(companyId: ${companyId}, name: "${name}", abbreviation: "${abbreviation}", bucketName: "${bucketName}", domains: "${domains}") {
            entity {
                id
                name
            }
        }
    }
`
}